import { render, staticRenderFns } from "./ShowMoreNotice.vue?vue&type=template&id=5223186b&scoped=true&"
import script from "./ShowMoreNotice.vue?vue&type=script&lang=js&"
export * from "./ShowMoreNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5223186b",
  null
  
)

export default component.exports